export default "__VITE_ASSET__$xuUX_hl__"